import React, { useEffect, useState } from "react"

import { Checkbox, Dropdown, Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useLocation } from "react-router"

import Icon from "../../Icon"
import SelectComponent from "../Select"
import { SelectTagRender } from "../Select/SelectTagRender"

import "./DropdownBlock.less"

const { Text } = Typography
const DropdownBlockTags = ({
  label,
  title,
  iconType,
  id,
  dropdownFilters,
  setDropdownFilters,
  searchPlaceholder,
  withHide,
  valueHide,
  onChangeHide,
  addGlobalFilter,
  removeGlobalFilter,
  onOpenChange,
  withNoValue,
  noValueLabel
}) => {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation()
  const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)
  const savedFilters = useSelector((state) => state.globalFilters.filters.user_email)
  const { pathname } = useLocation()

  const handleVisibleChange = (isOpen) => {
    setVisible(isOpen)
    onOpenChange?.(isOpen)
  }

  const handleChange = (value) => {
    setDropdownFilters({ [id]: [...value.map((v) => v?.trim())] })
    if (!value.length && valueHide) {
      onChangeHide(id, false)
    }
    if ((id === "user_email" || id === "email") && removeGlobalFilter && addGlobalFilter) {
      if (savedFilters) {
        const parsedFilters = savedFilters
        setDropdownFilters({ [id]: parsedFilters })
        parsedFilters.forEach((email) => {
          if (typeof email === "string" && email.trim()) {
            addGlobalFilter("user_email", email.trim())
          }
        })
        savedFilters.forEach((email) => {
          if (!value.includes(email)) {
            removeGlobalFilter("user_email")
          }
        })
        value.forEach((email) => {
          if (typeof email === "string" && email.trim()) {
            addGlobalFilter("user_email", email.trim())
          }
        })
      }
    }
  }

  const handleChangeNoValue = (checked) => {
    // If user checks "no value", set filter value to false (backend will interpret as "show only empty")
    if (checked) {
      setDropdownFilters({ [id]: false })
    } else {
      setDropdownFilters({ [id]: [] })
    }
  }

  useEffect(() => {
    if ((id === "user_email" || id === "email") && removeGlobalFilter && addGlobalFilter) {
      if (savedFilters) {
        const parsedFilters = savedFilters
        setDropdownFilters({ [id]: parsedFilters })
        parsedFilters.forEach((email) => {
          if (typeof email === "string" && email.trim()) {
            addGlobalFilter("user_email", email.trim())
          }
        })
      } else {
        setDropdownFilters(pathname === "/invoices" ? { email: [] } : { user_email: [] })
      }
    }
  }, [savedFilters, id])

  //text to display after closed dropdown
  function getSelectValue() {
    let result = null

    // Check if filter is set to \"no value\" mode (false)
    if (dropdownFilters === false) {
      return `${label}: ${noValueLabel || "NO values"}`
    }

    switch (true) {
      case dropdownFilters?.length === 1:
        result = dropdownFilters?.[0]
        break
      case dropdownFilters?.length > 1:
        result = t("Mixed Values")
        break
      default:
        break
    }

    return `${label}${result ? ": " + result : ""}`
  }

  return (
    <div
      className={cls("select-block", {
        "disabled-transition": isDisabledTransition
      })}
    >
      <Dropdown
        overlayClassName={"dropdown-database-wrapper"}
        getPopupContainer={() => document.getElementById("main-layout")}
        placement="bottomLeft"
        overlayStyle={{ width: 268 }}
        destroyPopupOnHide={!dropdownFilters?.length}
        visible={visible}
        onOpenChange={handleVisibleChange}
        dropdownRender={() => (
          <Flex vertical gap={8} className="dropdown-database-menu" style={{ padding: 12 }}>
            <Text strong>{t(title || label)}</Text>
            <SelectComponent
              size={"large"}
              suffixIcon={null}
              open={false}
              mode="tags"
              tagRender={SelectTagRender}
              defaultValue={Array.isArray(dropdownFilters) ? dropdownFilters : []}
              tokenSeparators={[","]}
              placeholder={t(searchPlaceholder)}
              onChange={(value) => handleChange(value)}
              disabled={dropdownFilters === false}
              className={"like-input"}
            />

            {withHide && (
              <Checkbox
                checked={valueHide}
                disabled={!dropdownFilters?.length}
                onChange={() => onChangeHide(id, !valueHide)}
              >
                Hide filtered accounts/alerts
              </Checkbox>
            )}

            {withNoValue && (
              <Checkbox
                checked={dropdownFilters === false}
                disabled={Array.isArray(dropdownFilters) && dropdownFilters.length > 0}
                onChange={(e) => handleChangeNoValue(e.target.checked)}
              >
                {t(noValueLabel)}
              </Checkbox>
            )}
          </Flex>
        )}
        trigger={["click"]}
      >
        <div
          className={cls("dropdown-database", id, {
            "ant-dropdown-active": dropdownFilters?.length
          })}
        >
          <Icon role="icon" type={iconType} />
          <Text className="dropdown-database_value">{getSelectValue()}</Text>
          <Icon type="chevron_down_small" className="arrow-icon" />
        </div>
      </Dropdown>
    </div>
  )
}

const areEqual = (prev, next) => {
  if (prev?.dropdownFilters === "all") {
    return next?.dropdownFilters === "all"
  } else {
    return (
      JSON.stringify(prev?.dropdownFilters) === JSON.stringify(next?.dropdownFilters) &&
      prev?.valueHide === next?.valueHide
    )
  }
}

export default React.memo(DropdownBlockTags, areEqual)
